import { z } from 'zod/v4';
import { zWorkoutStatusTaskInput, } from './workout-status-task';
export const GAMIFICATION_WORKOUT_STATUS_TASK_TYPE = 'GamificationWorkoutStatusTask';
/**
 * The gamification fan-out of a workout-status transition: the worker's
 * workout-status stage routes a `WorkoutStatusTask` here by enqueueing this
 * task back onto the integrations queue, and the gamification stage turns
 * it into the create-or-reverse API call. Carries the same pointer input as
 * the task that produced it — the gamification stage re-reads current state
 * at processing time, so the pointer stays safe across the extra hop.
 */
export const zGamificationWorkoutStatusTask = z.object({
    type: z.literal(GAMIFICATION_WORKOUT_STATUS_TASK_TYPE),
    input: zWorkoutStatusTaskInput,
});
/**
 * FIFO MessageGroupId — the same athlete-workout ordering as the source
 * task, so a reversal can never overtake the completion it reverses.
 */
export function gamificationWorkoutStatusMessageGroupId(data) {
    return `${data.input.workoutId}:${data.input.profileId}`;
}
/**
 * FIFO MessageDeduplicationId prefix. The dedup id must NOT equal the source
 * task's own dedup id (the bare `taskId`): the integrations queue dedups
 * queue-wide over a 5-minute window, and the fan-out is sent seconds after
 * the source — a bare `taskId` would make SQS silently swallow the fan-out
 * as a duplicate of the message that produced it (200 OK, never delivered).
 * The prefix namespaces the fan-out while keeping it deterministic in the
 * source `taskId`: a redelivered source message enqueues a second fan-out
 * with the same dedup id and SQS collapses it — the two-hop flow cannot
 * double-send.
 */
const GAMIFICATION_DEDUP_PREFIX = 'gamification:';
export function gamificationWorkoutStatusMessageDeduplicationId(data) {
    return `${GAMIFICATION_DEDUP_PREFIX}${data.input.taskId}`;
}
//# sourceMappingURL=gamification-workout-status-task.js.map